import colors from './colors';
import fontSize from './fontSize';
import fontWeight from './fontWeight';
import lineHeight from './lineHeight';
import media from './media';

const theme = {
  colors,
  fontSize,
  fontWeight,
  media,
  lineHeight,
};

export default theme;
